import { sanitizeFilename } from './sanitize-filename';

function endsWithCommonExtension(fileName: string): boolean {
  return /\.(jpg|jpeg|png|tif|tiff|gif|mp4)$/i.test(fileName);
}

export function createDownloadFilename(assetName: string, ext: string, fileNameRef?: string): string {
  const baseName = endsWithCommonExtension(assetName) ? assetName.replace(/\.[^/.]+$/, '') : assetName;
  const fileType = fileNameRef && fileNameRef !== 'main' ? '_' + fileNameRef : '';
  return sanitizeFilename(`${baseName}${fileType}.${ext}`);
}

export function cleanupDownloadFilename(fileName: string): string {
  if (fileName) {
    const parts = fileName.split('.');
    if (parts.length > 1) {
      const ext = parts.pop();
      const baseName = parts
        .join('.')
        .replace('.' + ext, '')
        .replace('_main', '');
      return sanitizeFilename(`${baseName}.${ext}`);
    }
    return sanitizeFilename(fileName);
  }
  return fileName;
}
